// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1ki4e","inputDescription":"styles_inputDescription__3rgkv"};